import React, { CSSProperties, ReactElement, ReactNode } from 'react';
import { reactNodeIsOfType } from '../../utils';
import AntdLayout from 'antd/lib/layout';

export interface LayoutProps {
   className?: string;
   style?: CSSProperties;
}

export interface LayoutHeaderProps {
   className?: string;
   style?: CSSProperties;
}

export interface LayoutFooterProps {
   className?: string;
   style?: CSSProperties;
}

export interface LayoutContentProps {
   className?: string;
   style?: CSSProperties;
}

export interface LayoutSiderProps {
   breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
   collapsed?: boolean;
   collapsedWidth?: number;
   collapsible?: boolean;
   defaultCollapsed?: boolean;
   reverseArrow?: boolean;
   theme?: 'light' | 'dark';
   trigger?: ReactNode;
   width?: number | string;
   className?: string;
   style?: CSSProperties;
   onCollapse?: () => void;
}

export const Layout = (props: React.PropsWithChildren<LayoutProps>) => {
   return (
      <AntdLayout
         className={props.className}
         style={props.style}
      >
         {
            React.Children.map(props.children, child => {
               if (reactNodeIsOfType(child, LayoutHeader)) {
                  const layoutHeader = child as ReactElement;
                  const layoutHeaderProps = layoutHeader.props as React.PropsWithChildren<LayoutHeaderProps>;

                  return (
                     <AntdLayout.Header
                        className={layoutHeaderProps.className}
                        style={layoutHeaderProps.style}
                     >
                        {layoutHeaderProps.children}
                     </AntdLayout.Header>
                  );
               }

               if (reactNodeIsOfType(child, LayoutFooter)) {
                  const layoutFooter = child as ReactElement;
                  const layoutFooterProps = layoutFooter.props as React.PropsWithChildren<LayoutFooterProps>;

                  return (
                     <AntdLayout.Footer
                        className={layoutFooterProps.className}
                        style={layoutFooterProps.style}
                     >
                        {layoutFooterProps.children}
                     </AntdLayout.Footer>
                  );
               }

               if (reactNodeIsOfType(child, LayoutContent)) {
                  const layoutContent = child as ReactElement;
                  const layoutContentProps = layoutContent.props as React.PropsWithChildren<LayoutContentProps>;

                  return (
                     <AntdLayout.Content
                        className={layoutContentProps.className}
                        style={layoutContentProps.style}
                     >
                        {layoutContentProps.children}
                     </AntdLayout.Content>
                  );
               }

               if (reactNodeIsOfType(child, LayoutSider)) {
                  const layoutSider = child as ReactElement;
                  const layoutSiderProps = layoutSider.props as React.PropsWithChildren<LayoutSiderProps>;

                  return (
                     <AntdLayout.Sider
                        breakpoint={layoutSiderProps.breakpoint}
                        collapsed={layoutSiderProps.collapsed}
                        collapsedWidth={layoutSiderProps.collapsedWidth}
                        collapsible={layoutSiderProps.collapsible}
                        defaultCollapsed={layoutSiderProps.defaultCollapsed}
                        reverseArrow={layoutSiderProps.reverseArrow}
                        theme={layoutSiderProps.theme}
                        trigger={layoutSiderProps.trigger}
                        width={layoutSiderProps.width}
                        className={layoutSiderProps.className}
                        style={layoutSiderProps.style}
                        onCollapse={layoutSiderProps.onCollapse}
                     >
                        {layoutSiderProps.children}
                     </AntdLayout.Sider>
                  );
               }

               return undefined;
            })
         };
      </AntdLayout>
   );
};

export class LayoutHeader extends React.Component<LayoutHeaderProps> {
}

export class LayoutFooter extends React.Component<LayoutFooterProps  > {
}

export class LayoutContent extends React.Component<LayoutContentProps> {
}

export class LayoutSider extends React.Component<LayoutSiderProps> {
}
